<template>
	<div class="page-container">
		<div class="search-bar bg_a flex_c">
			<div class="search-input flex_a">
				<van-icon name="search" />
				<input type="text" name="keyword" v-model="keyword" placeholder="输入关键字搜索" @keyup.enter="onSearch" />
			</div>
			<div class="search-btn" @click="onSearch">搜索</div>
		</div>
		<div class="merchant-page flex_c">
			<div class="category-side">
				<div class="category-item ellipsis_1" :class="{ active: activeCategory === item.id }" v-for="item in categories"
					:key="item.id" @click="selectCategory(item.id)">
					{{ item.name }}
				</div>
			</div>

			<div class="merchant-side" ref="merchantSide">
				<div class="merchant-count">共 {{ total }} 个商家</div>

				<van-pull-refresh v-model="refreshing" @refresh="onRefresh">
					<div class="empty-box" v-if="!loading && finished && list.length === 0">暂无商家</div>
					<van-list :offset="40" v-else v-model="loading" :finished="finished" :immediate-check="false"
						:finished-text="finished ? '没有更多了~' : ''" @load="onLoad">
						<div class="merchant-card bg_a flex_a" v-for="item in list" :key="item.id" @click="goDetail(item.id)">
							<div class="merchant-logo">
								<img v-if="item.logo" class="merchant-logo-img" :src="getImageUrl(item.logo)" />
							</div>
							<div class="merchant-main flex_b">
								<div class="merchant-name ellipsis_1">{{ item.retailerName }}</div>
								<div class="merchant-rebate">
									{{ item.memberCommissionValue }}%返利
								</div>
								<div class="merchant-desc ellipsis_1">{{ item.synopsis }}</div>
							</div>
						</div>
					</van-list>

				</van-pull-refresh>
			</div>
		</div>

		<div class="back-to-top" :class="{ show: showBackToTop }" @click="scrollToTop">
			<van-icon name="back-top" />
		</div>
	</div>
</template>

<script>
	import {
		getCategoryList,
		getRetailerListByCategory,
		imageUrl
	} from '@/apis/api.js'

	export default {
		name: 'Merchant',
		data() {
			return {
				keyword: '',
				activeCategory: 'hot',
				categories: [],
				list: [],
				pageNum: 0,
				total: 0,
				pageSize: 10,

				loading: false,
				refreshing: false,
				finished: false,

				showBackToTop: false
			}
		},
		mounted() {
			this.loadCategoryList()
		},
		beforeDestroy() {
			if (this.scrollListener && this.$refs.merchantSide) {
				this.$refs.merchantSide.removeEventListener('scroll', this.scrollListener)
			}
		},
		methods: {
			getImageUrl(path) {
				return imageUrl(path)
			},
			loadCategoryList() {
				getCategoryList()
					.then(res => {
						this.categories = res.categories || []
					}).catch(() => {
						this.$toast('加载失败')
						this.categories = [{
							id: 'hot',
							name: '热门',
							type: 'hot'
						}]
					})
				this.onLoad()
				this.$nextTick(() => {
					const merchantSide = this.$refs.merchantSide
					if (merchantSide) {
						this.scrollListener = () => {
							this.showBackToTop = merchantSide.scrollTop > 300
						}
						merchantSide.addEventListener('scroll', this.scrollListener)
					}
				})
			},
			getList() {
				this.pageNum++
				getRetailerListByCategory({
						keyword: this.keyword,
						categoryId: this.activeCategory,
						pageNum: this.pageNum,
						pageSize: this.pageSize
					})
					.then(res => {
						const rows = res.rows || []
						const total = res.total || 0
						this.total = total
						this.list = this.list.concat(rows)
						if (this.list.length >= this.total) {
							this.finished = true
						} else {
							this.finished = false
						}
					})
					.catch(e => {
						this.finished = true
						if (!e.handled) {
							this.$toast('加载失败')
						}
					})
					.finally(() => {
						this.loading = false
						this.refreshing = false
					})
			},
			onLoad() {
				if (this.refreshing || this.finished) {
					return
				}
				this.getList()
			},
			onRefresh() {
				this.pageNum = 0
				this.list = []
				this.finished = false
				this.getList()
			},
			onSearch() {
				this.pageNum = 0
				this.list = []
				this.total = 0
				this.loading = true
				this.finished = false
				this.getList()
			},
			selectCategory(id) {
				this.activeCategory = id
				this.pageNum = 0
				this.list = []
				this.total = 0
				this.loading = true
				this.finished = false
				this.getList()
				this.scrollMerchantToTop()
			},
			scrollMerchantToTop() {
				const merchantSide = this.$refs.merchantSide
				if (merchantSide) {
					merchantSide.scrollTop = 0
				}
			},
			goDetail(id) {
				this.$router.push('/detail?id=' + id)
			},
			scrollToTop() {
				const merchantSide = this.$refs.merchantSide
				if (merchantSide) {
					merchantSide.scrollTo({
						top: 0,
						behavior: 'smooth'
					})
				}
			}
		},
	}
</script>

<style lang="scss" scoped>
	.page-container {
		padding-bottom: 48px;

		.search-bar {
			padding: 10px 14px;

			.search-input {
				flex: 1;
				background: #f5f5f5;
				border-radius: 4px;
				padding: 0 10px;
				height: 36px;
				line-height: 36px;

				.van-icon {
					flex: none;
					font-size: 16px;
					color: #999;
					margin-right: 10px;
				}

				input {
					height: 36px;
					line-height: 36px;
					flex: 1;
					font-size: 14px;
					color: #333;
				}
			}

			.search-btn {
				flex: none;
				margin-left: 10px;
				font-size: 14px;
				color: #333;
				font-weight: bold;
				cursor: pointer;
			}
		}

		.merchant-page {
			width: 100%;
			height: calc(100vh - 104px);
			overflow: hidden;

			.category-side {
				box-sizing: border-box;
				width: 100px;
				flex: none;
				height: 100%;
				background: #F8F8F8;
				overflow-y: auto;

				.category-item {
					width: 100%;
					padding: 0 10px;
					color: #333;
					font-size: 13px;
					text-align: center;
					line-height: 50px;
					height: 50px;
					box-sizing: border-box;

					&.active {
						position: relative;
						color: #e33737;
						background: #ffffff;
						font-weight: bold;

						&::before {
							content: '';
							position: absolute;
							left: 0;
							top: 50%;
							transform: translateY(-50%);
							width: 4px;
							height: 20px;
							border-radius: 2px;
							background-color: #e33737;
						}
					}
				}
			}

			.merchant-side {
				box-sizing: border-box;
				flex: 1;
				height: 100%;
				padding: 0 10px 16px;
				overflow-y: auto;

				.merchant-count {
					padding: 8px 0;
					color: #888888;
					font-size: 12px;
				}

				.empty-box {
					padding: 60px 0;
					color: #999999;
					text-align: center;
					font-size: 14px;
				}

				.merchant-card {
					height: 80px;
					margin-bottom: 10px;
					padding: 12px 10px;
					border-radius: 10px;

					.merchant-logo {
						width: 80px;
						height: 80px;
						flex: none;
						background: #fff;
						border-radius: 8px;
						overflow: hidden;
						margin-right: 12px;

						.merchant-logo-img {
							width: 100%;
							height: 100%;
							border-radius: 8px;
							overflow: hidden;
							object-fit: contain;
						}
					}

					.merchant-main {
						flex: 1;
						height: 80px;
						flex-direction: column;

						.merchant-name {
							width: 100%;
							font-size: 14px;
							color: #222222;
							font-weight: bold;
						}

						.merchant-rebate {
							width: 100%;
							color: #e33737;
							font-size: 12px;
						}

						.merchant-desc {
							width: 100%;
							color: #909090;
							font-size: 12px;
						}
					}
				}
			}
		}

		.back-to-top {
			position: fixed;
			right: 20px;
			bottom: 90px;
			width: 44px;
			height: 44px;
			background: #ffffff;
			border-radius: 50%;
			box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
			display: flex;
			align-items: center;
			justify-content: center;
			opacity: 0;
			visibility: hidden;
			transition: all 0.3s ease;
			z-index: 1000;

			&.show {
				opacity: 1;
				visibility: visible;
			}

			.van-icon {
				font-size: 24px;
				color: #444;
			}
		}
	}
</style>